import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(function Textarea({ className, ...rest }, ref) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm font-mono',
        'placeholder:text-slate-400',
        'focus:outline-none focus:ring-2 focus:ring-brand focus:border-brand',
        'disabled:cursor-not-allowed disabled:bg-slate-50',
        className,
      )}
      spellCheck={false}
      {...rest}
    />
  );
});
